import { render, staticRenderFns } from "./pop-up-container.vue?vue&type=template&id=318adc8e&scoped=true"
import script from "./pop-up-container.vue?vue&type=script&lang=js"
export * from "./pop-up-container.vue?vue&type=script&lang=js"
import style0 from "./pop-up-container.vue?vue&type=style&index=0&id=318adc8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318adc8e",
  null
  
)

export default component.exports